<template>
  <grid-component 
      :gridId="gridId"
      :fields="fields"
      :itemData="qboItems"
  />  
</template>

<script>
import {mapGetters} from 'vuex';
import fields from './fields';
import GridComponent from '@/shared/components/GridComponent'
import {GRID_ID} from '@/shared/constants';

export default {
  components: {
    GridComponent
  },
  data() {
    return {
      fields,
      gridId: GRID_ID.QBO_ITEMS_GRID
    }
  },
  computed: {
    ...mapGetters('quickBooks', ['qboItems'])
  }
}
</script>

<style>

</style>